import React from 'react';
import { FacebookIcon, InstagramIcon, TwitterIcon, MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
import { Footer as ShopifyFooter } from './ShopifyFooter1';
export function Footer() {
  return <>
      <ShopifyFooter data-id="element-56" />
      
    </>;
}